import { Text } from "@oysterhr/ui"
import type { ReactNode } from "react"

function ItemTitle({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="mb-1 flex w-full items-center justify-between">
        <Text className="font-semibold">{children}</Text>
      </div>
      <hr />
    </>
  )
}

function ItemContent({ children }: { children: ReactNode }) {
  return <div className="flex items-start pt-4">{children}</div>
}

function Item({ children }: { children: ReactNode }) {
  return (
    <div className="relative h-full rounded-lg bg-gray-100 p-4">
      <div className="flex w-full flex-col flex-wrap divide-y">{children}</div>
    </div>
  )
}

export const ItemsWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div className="mb-4 mt-2 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 ">
      {children}
    </div>
  )
}

ItemsWrapper.Item = Item
ItemsWrapper.Title = ItemTitle
ItemsWrapper.Content = ItemContent
